var _use, _use2, _use3, _use4, _use5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPokerLedgerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "tiny-ps",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Poker Ledger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-22.099 -5.237 291.824)scale(4.7057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.753,
    height: 42.303,
    x: 29.062,
    y: 33.912,
    ry: 3.709,
    style: {
      fill: "#fbfbfb",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0.76806,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M49.433 47.632c-2.704-.044-6.474 3.201-6.53 3.25-.47-.395-3.976-3.268-6.486-3.239-1.315.015-2.373.83-2.61 3.224-.694 7.013 8.41 11.28 9.114 11.599l.06.029h.004l.065-.033c.7-.32 9.713-4.584 9.018-11.596-.237-2.393-1.306-3.213-2.636-3.235z",
    style: {
      fill: "#b23b3b",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(.23223 -.01601 -.01601 .26517 23.91 24.738)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7.084 -530.469 1404.863)scale(4.7057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.753,
    height: 42.303,
    x: 62.158,
    y: 34.548,
    ry: 3.709,
    style: {
      fill: "#fbfbfb",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0.768085,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M76 47.427a5.186 4.537 0 0 0-5.186 4.537 5.186 4.537 0 0 0 .19 1.199 5.186 4.537 0 0 0-.15-.003 5.186 4.537 0 0 0-5.185 4.537 5.186 4.537 0 0 0 5.185 4.537 5.186 4.537 0 0 0 4.907-3.105c-.45 1.605-1.055 2.654-2.464 3.98l4.658-.04c.598.266-1.958-2.822-2.12-3.936a5.186 4.537 0 0 0 4.905 3.101 5.186 4.537 0 0 0 5.185-4.537 5.186 4.537 0 0 0-4.93-4.532 5.186 4.537 0 0 0 .19-1.2 5.186 4.537 0 0 0-5.186-4.538z",
    style: {
      fill: "#222e73",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(.22673 -.00181 -.00181 .2411 50.382 25.822)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(5.012 1587.826 -2658.956)scale(4.7057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.753,
    height: 42.303,
    x: 93.789,
    y: 34.519,
    ry: 3.709,
    style: {
      fill: "#fbfbfb",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0.76806,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M98.072 55.78c1.922-.014 9.24 10.898 8.872 12.741.662-1.076 6.244-9.82 10.316-12.1-4.434-4.392-7.926-8.888-9.473-13.601-1.573 4.43-7.083 10.616-9.715 12.96z",
    style: {
      fill: "#b23b3b",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "matrix(.14852 .00251 .00251 .17696 82.825 28.559)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "rotate(14.66 916.148 -1216.456)scale(4.7057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.753,
    height: 42.303,
    x: 127.534,
    y: 34.866,
    ry: 3.709,
    style: {
      fill: "#fbfbfb",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0.768085,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M139.227 61.61c-17.673.822 2.925-16.973 2.925-16.973s17.88 19.115 1.755 16.841c-1.08-.152-4.212 1.053 0 5.921l-5.382-.131s3.804-5.802.702-5.658z",
    style: {
      fill: "#222e73",
      fillOpacity: 1,
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(.18014 .0125 .0125 .22464 105.304 25.265)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M93.95 48.427a9.25 9.25 0 0 0-9.25 9.25 9.25 9.25 0 0 0 9.25 9.25 9.25 9.25 0 0 0 9.25-9.25 9.25 9.25 0 0 0-9.25-9.25zm0 .35a8.9 8.9 0 1 1 0 17.8 8.9 8.9 0 0 1 0-17.8z",
    style: {
      fill: "#222e73",
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round"
    },
    transform: "translate(-65.676 -79.994)scale(4.7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.95 48.777a8.9 8.9 0 1 0 0 17.8 8.9 8.9 0 0 0 0-17.8zm1.522.257c.992.197 1.94.577 2.806 1.1l-.328.54a8 8 0 0 0-2.6-1.023zm-3.052.002.123.617a8 8 0 0 0-2.6 1.027l-.328-.54a8.7 8.7 0 0 1 2.805-1.104zm4.377.507a.21.21 0 0 0-.195.134c-.04.11.02.231.127.274a.22.22 0 0 0 .28-.113.213.213 0 0 0-.125-.28.2.2 0 0 0-.087-.015zm-5.701.003a.2.2 0 0 0-.088.016.213.213 0 0 0-.125.28.217.217 0 0 0 .28.113.22.22 0 0 0 .128-.275.21.21 0 0 0-.195-.134zm2.855.131a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm6.646 2.431a9.3 9.3 0 0 1 1.564 2.583l-.585.233a8.6 8.6 0 0 0-1.461-2.404zm-13.299.008.483.411a8.6 8.6 0 0 0-1.459 2.406l-.585-.232a9.2 9.2 0 0 1 1.561-2.585zm13.88 1.17a.2.2 0 0 0-.079.03.22.22 0 0 0-.064.296c.06.1.191.137.293.079a.214.214 0 0 0 .068-.3.22.22 0 0 0-.218-.106zm-14.522.007a.22.22 0 0 0-.156.107.214.214 0 0 0 .07.3c.1.058.23.02.292-.08a.22.22 0 0 0-.065-.297.2.2 0 0 0-.14-.03zm15.456 4.384h.636a8.2 8.2 0 0 1-.58 2.967l-.586-.23c.344-.87.534-1.796.53-2.737zm-16.322.01c-.003.94.187 1.865.532 2.735l-.585.232a8.2 8.2 0 0 1-.584-2.967zm16.536 1.23a.217.217 0 0 0-.246.174.22.22 0 0 0 .16.256.213.213 0 0 0 .253-.174.213.213 0 0 0-.167-.256zm-16.748.01a.21.21 0 0 0-.167.256.213.213 0 0 0 .252.173.22.22 0 0 0 .161-.255.22.22 0 0 0-.246-.174zm14.537 3.907.482.412a9.6 9.6 0 0 1-2.302 1.963l-.328-.539a9 9 0 0 0 2.148-1.836zm-12.322.008a9 9 0 0 0 2.15 1.833l-.328.54a9.6 9.6 0 0 1-2.304-1.961zm11.543 1.022a.23.23 0 0 0-.157.053.22.22 0 0 0-.031.303.214.214 0 0 0 .307.02.215.215 0 0 0 .029-.307.2.2 0 0 0-.148-.07zm-10.763.006a.2.2 0 0 0-.147.07.214.214 0 0 0 .028.307c.096.081.234.07.308-.02a.22.22 0 0 0-.033-.303.22.22 0 0 0-.156-.054zm6.777 1.833.122.617a8 8 0 0 1-1.521.155 8 8 0 0 1-1.511-.153l.121-.617q.685.136 1.39.133.71.002 1.399-.135zm-1.4.24a.22.22 0 0 0-.216.21.215.215 0 0 0 .217.217h.005a.215.215 0 0 0 .22-.217.22.22 0 0 0-.22-.21z",
    style: {
      fill: "#f2f3fb",
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round"
    },
    transform: "translate(-65.676 -79.994)scale(4.7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.95 49.677a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm0 .25a7.75 7.75 0 1 1 0 15.5 7.75 7.75 0 0 1 0-15.5z",
    style: {
      fill: "#222e73",
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round"
    },
    transform: "translate(-65.676 -79.994)scale(4.7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.95 49.927a7.75 7.75 0 1 0 .001 15.5 7.75 7.75 0 0 0 0-15.5zm0 .4a7.35 7.35 0 1 1 0 14.7 7.35 7.35 0 0 1 0-14.7z",
    style: {
      fill: "#f2f3fb",
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round"
    },
    transform: "translate(-65.676 -79.994)scale(4.7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.95 50.327a7.35 7.35 0 1 0 .001 14.7 7.35 7.35 0 0 0 0-14.7z",
    style: {
      fill: "#222e73",
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round"
    },
    transform: "translate(-65.676 -79.994)scale(4.7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.472 49.034-.122.617c.915.18 1.795.535 2.6 1.023l.328-.54a8.7 8.7 0 0 0-2.806-1.1Zm-3.052.002c-.992.198-1.94.58-2.805 1.104l.328.54a8 8 0 0 1 2.6-1.027zm4.377.507q.043-.001.087.016a.213.213 0 0 1 .126.279.22.22 0 0 1-.28.113.22.22 0 0 1-.128-.274.21.21 0 0 1 .195-.134zm-5.701.003a.21.21 0 0 1 .195.134.22.22 0 0 1-.128.275.217.217 0 0 1-.28-.113.213.213 0 0 1 .125-.28.2.2 0 0 1 .088-.016zm9.501 2.562-.482.412a8.6 8.6 0 0 1 1.46 2.404l.586-.233a9.3 9.3 0 0 0-1.564-2.583zm-13.299.008a9.2 9.2 0 0 0-1.56 2.585l.584.232a8.6 8.6 0 0 1 1.459-2.406zm13.88 1.17a.22.22 0 0 1 .218.106.214.214 0 0 1-.068.299.22.22 0 0 1-.293-.08.22.22 0 0 1 .064-.296.2.2 0 0 1 .079-.03zm-14.46.007a.2.2 0 0 1 .08.03.22.22 0 0 1 .064.297.22.22 0 0 1-.293.08.214.214 0 0 1-.07-.3.22.22 0 0 1 .22-.107zm15.394 4.384a7.4 7.4 0 0 1-.53 2.736l.586.231a8.2 8.2 0 0 0 .58-2.967zm-16.322.01h-.637a8.2 8.2 0 0 0 .584 2.967l.585-.232a7.4 7.4 0 0 1-.532-2.735Zm16.536 1.23c.114.02.191.133.167.256a.213.213 0 0 1-.252.174.22.22 0 0 1-.161-.256.217.217 0 0 1 .246-.174zm-16.748.01c.115-.02.224.06.246.174a.22.22 0 0 1-.161.255.213.213 0 0 1-.252-.173.21.21 0 0 1 .167-.256zm14.537 3.907a9 9 0 0 1-2.148 1.836l.328.54a9.6 9.6 0 0 0 2.302-1.964Zm-12.322.008-.482.412a9.6 9.6 0 0 0 2.304 1.961l.328-.54a9 9 0 0 1-2.15-1.833zm11.543 1.022a.2.2 0 0 1 .148.07.215.215 0 0 1-.029.306.215.215 0 0 1-.307-.02.22.22 0 0 1 .031-.303.23.23 0 0 1 .157-.053zm-10.763.006a.22.22 0 0 1 .156.054.22.22 0 0 1 .033.302.215.215 0 0 1-.308.02.214.214 0 0 1-.028-.306.2.2 0 0 1 .147-.07zm6.777 1.833q-.69.137-1.4.135a7 7 0 0 1-1.389-.133l-.121.617q.743.148 1.51.153a8 8 0 0 0 1.522-.155zm-1.4.24h.006a.22.22 0 0 1 .22.21.215.215 0 0 1-.22.217h-.005a.215.215 0 0 1-.217-.217.22.22 0 0 1 .217-.21z",
    style: {
      fill: "#222e73",
      stroke: "#222e73",
      strokeWidth: 0,
      strokeLinejoin: "round"
    },
    transform: "translate(-65.676 -79.994)scale(4.7057)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(180 250 250)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.59 59.782c-3.267 4.779-6.189 7.723-9.724 10.026 3.69 2.023 6.376 4.203 9.724 8.764h83.09c3.348-4.56 6.034-6.74 9.724-8.764-3.535-2.303-6.457-5.247-9.724-10.026H56.119z",
    style: {
      fill: "#f2f3fb",
      stroke: "#222e73",
      strokeWidth: 1.40688
    },
    transform: "translate(-14.155 -75.581)scale(4.7057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.998 63.886h2.831q1.149 0 1.763.18.62.18.928.521.314.34.42.828.114.48.114 1.496v.941q0 1.035-.214 1.509-.213.474-.787.728-.568.253-1.49.253h-.754v4.354H20zm2.811 1.85v2.75q.12.007.207.007.387 0 .534-.187.154-.194.154-.794v-.888q0-.555-.174-.721-.173-.167-.72-.167zm10.075 3.211v2.17q0 1.195-.12 1.756-.12.554-.514 1.041-.394.481-1.015.715-.614.227-1.415.227-.895 0-1.516-.194-.62-.2-.968-.594-.34-.4-.487-.961-.147-.568-.147-1.696v-2.27q0-1.236.267-1.93t.961-1.115q.695-.42 1.776-.42.908 0 1.556.273.654.267 1.008.701t.48.895q.134.46.134 1.402zm-2.697-.668q0-.68-.074-.854-.073-.18-.313-.18t-.32.18q-.081.173-.081.854v4q0 .627.08.82.08.188.314.188.24 0 .314-.174.08-.173.08-.748zm9.394-2.443-1.095 3.532 1.422 5.328H37.31l-.842-3.86v3.86h-2.697v-10.81h2.697v4.54l.842-2.59zm6.836 4.587h-3.491v1.916q0 .6.086.774.087.174.334.174.307 0 .407-.227.107-.234.107-.895v-1.168h2.557v.654q0 .821-.106 1.262-.1.44-.481.941-.38.501-.968.755-.581.247-1.462.247-.855 0-1.51-.247-.654-.247-1.02-.675-.361-.434-.502-.948-.14-.52-.14-1.509v-2.583q0-1.162.314-1.83.314-.674 1.028-1.028.715-.36 1.643-.36 1.135 0 1.87.434.74.427 1.034 1.141.3.708.3 1.996zm-2.704-1.443v-.647q0-.688-.073-.888t-.3-.2q-.28 0-.348.173-.066.167-.066.915v.647zm6.283-3.144-.107 1.161q.588-1.248 1.703-1.321v3.117q-.741 0-1.089.2-.347.201-.427.562-.08.353-.08 1.642v3.499h-2.697v-8.86zm7.498-1.95v8.646h1.709v2.164h-4.52v-10.81Zm8.419 6.537H62.42v1.916q0 .6.087.774t.334.174q.307 0 .407-.227.107-.234.107-.895v-1.168h2.557v.654q0 .821-.107 1.262-.1.44-.48.941-.381.501-.969.755-.58.247-1.462.247-.855 0-1.509-.247t-1.021-.675q-.36-.434-.501-.948-.14-.52-.14-1.509v-2.583q0-1.162.313-1.83.314-.674 1.029-1.028.714-.36 1.642-.36 1.135 0 1.87.434.74.427 1.034 1.141.3.708.3 1.996zm-2.704-1.443v-.647q0-.688-.074-.888-.073-.2-.3-.2-.28 0-.347.173-.067.167-.067.915v.647zm9.72-5.094v10.81h-2.696v-.641q-.388.4-.815.6t-.895.2q-.627 0-1.088-.326-.46-.334-.594-.768-.127-.434-.127-1.416V68.2q0-1.021.127-1.449.133-.427.6-.747.468-.327 1.116-.327.5 0 .914.18.421.18.762.54v-2.51zm-2.696 4.18q0-.488-.087-.655-.08-.166-.327-.166-.24 0-.328.153-.08.147-.08.668v4.34q0 .54.08.714.08.167.308.167.26 0 .347-.187.087-.194.087-.935zm9.794-2.23v6.823q0 1.382-.067 1.79-.06.4-.447.847-.387.454-1.082.688-.687.24-1.736.24-1.288 0-2.07-.44-.78-.434-.807-1.716h2.617q0 .587.427.587.307 0 .408-.18t.1-.754v-.668q-.347.314-.735.474-.38.16-.8.16-.729 0-1.203-.293-.467-.294-.64-.768-.174-.48-.174-1.362v-3.218q0-1.262.454-1.816t1.382-.554q.507 0 .921.207.42.206.748.62l.194-.667zm-2.704 2.35q0-.608-.073-.775-.067-.166-.308-.166-.233 0-.333.193-.094.187-.094.748v2.978q0 .594.074.774.073.174.307.174.267 0 .347-.214t.08-.968zm9.774 2.237h-3.491v1.916q0 .6.086.774.087.174.334.174.307 0 .407-.227.107-.234.107-.895v-1.168h2.557v.654q0 .821-.106 1.262-.1.44-.481.941-.38.501-.968.755-.581.247-1.462.247-.855 0-1.51-.247-.654-.247-1.02-.675-.361-.434-.502-.948-.14-.52-.14-1.509v-2.583q0-1.162.314-1.83.314-.674 1.028-1.028.715-.36 1.643-.36 1.135 0 1.87.434.74.427 1.034 1.141.3.708.3 1.996zm-2.704-1.443v-.647q0-.688-.073-.888t-.3-.2q-.28 0-.348.173-.066.167-.066.915v.647zm6.283-3.144-.107 1.161q.588-1.248 1.703-1.321v3.117q-.741 0-1.089.2-.347.201-.427.562-.08.353-.08 1.642v3.499h-2.697v-8.86z",
    "aria-label": "Poker Ledger",
    style: {
      fontSize: "13.6735px",
      fontFamily: "Impact",
      InkscapeFontSpecification: "&quot",
      fill: "#222e73",
      stroke: "#222e73",
      strokeWidth: 0
    },
    transform: "translate(-14.155 -75.581)scale(4.7057)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerLedgerLogo);
export default __webpack_public_path__ + "static/media/poker-ledger-logo.0c2440c3a9f0d5db5bcf91e80226f7a1.svg";
export { ForwardRef as ReactComponent };